<!-- <video autoplay [muted]="'muted'" loop id="myVideo">
  <source src="../../assets/video/loginVideo.mp4" type="video/mp4" />
  Your browser does not support HTML5 video.
</video> -->
<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<!-- <form [formGroup]="loginForm" class="loginPage">
  <div class="logo">
    <img src="../../../../../assets/images/Ignite Logo Black Transparent-PhotoRoom.png" alt="" class="logoImg" />
  </div>
  <div class="userName">
    <label>User Name</label>
    <input type="text" formControlName="userName" placeholder="Username" />
  </div>

  <div class="password">
    <label>Password</label>
	<div class="d-flex">
		<input type="password" formControlName="password" placeholder="Password" id="password_input" class="flex-child"/>
		<div *ngIf="loginForm.get('password')?.value.length === 0; else passwordIsTyped">
			<img src="../../../../../assets/images/view-grey.png" *ngIf="passwordType === 'password'" id="password_eye" (click)="changePasswordType('text')" class="flex-child">
			<img src="../../../../../assets/images/hide-grey.png" *ngIf="passwordType === 'text'" id="password_eye" (click)="changePasswordType('password')" class="flex-child">
		</div>

		<ng-template #passwordIsTyped>
			<img src="../../../../../assets/images/view.png" *ngIf="passwordType === 'password'" id="password_eye" (click)="changePasswordType('text')" class="flex-child">
			<img src="../../../../../assets/images/hide.png" *ngIf="passwordType === 'text'" id="password_eye" (click)="changePasswordType('password')" class="flex-child">
		</ng-template>
	</div>
  </div>

  <div id="submission_box">
    <div>
      <a class="forget-password" [routerLink]="'/forgot-password'">Forgot Password?</a>
    </div>
	  <button class="loginBtn" (click)="login()">Login</button>
  </div>
</form> -->







<div class="auth-box">
  <form [formGroup]="loginForm" class="inner-box">
    <div class="logo">
      <img src="../../../../../assets/images/Ignite Logo Black Transparent-PhotoRoom.png" alt="" />
    </div>

    <div class="input-box">
      <label>User Name</label>
      <input type="text" formControlName="userName" />
    </div>
  
    <div class="input-box">
      <label>
        <span>Password</span> 
        <a class="forget-password" [routerLink]="'/forgot-password'">Forgot?</a>
      </label>
      <div class="password-input">
        <input [type]="passwordType" formControlName="password"/>
        <div class="password-toggle-icon" (click)="loginForm.get('password')?.value.length > 0 && togglePasswordVisibility()" 
          [ngStyle]="{'pointer-events': loginForm.get('password')?.value?.length === 0 ? 'none' : 'auto'}">
          <mat-icon [ngStyle]="{'color': loginForm.get('password')?.value?.length === 0 ? 'gray' : 'black'}" *ngIf="passwordType === 'password'">visibility_off</mat-icon>
          <mat-icon [ngStyle]="{'color': loginForm.get('password')?.value?.length === 0 ? 'gray' : 'black'}" *ngIf="passwordType === 'text'">visibility</mat-icon>
        </div>
      </div>
    </div>

    <div class="login-btn-box">
      <button mat-raised-button (click)="login()">Login</button>
    </div>
  </form>
</div>

